function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { MODAL_ELEMENTS, MODAL_HEADER_ELEMENTS, MODAL_FOOTER_ELEMENTS, MODAL_LAYOUT_ELEMENTS } from "./constants";
import { MODAL_BUTTON_VARIANTS } from "./Button/constants";
var checkElementsValidity = function checkElementsValidity(currentSlotName, componentsObject, content) {
  var childTypeNames = React.Children.map(content, function (child) {
    var _child$type;
    var childTypeName = child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name;
    return childTypeName;
  });
  var requiredElements = Object.keys(componentsObject).filter(function (item) {
    return componentsObject[item].isRequired;
  });
  var errorElements = requiredElements.map(function (item) {
    if (!childTypeNames || !childTypeNames.includes(item)) {
      return item;
    }
    return null;
    // Ignore `null` entries
  }).filter(Boolean);
  var numberOfOccurences = (childTypeNames || []).reduce(function (acc, element) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, element, acc[element] ? acc[element] + 1 : 1));
  }, {});
  var checkNumberOfOccurences = Object.keys(numberOfOccurences).filter(function (item) {
    if (componentsObject[item]) {
      return numberOfOccurences[item] > componentsObject[item].maxOccurences;
    }
    return false;
  });
  if (checkNumberOfOccurences.length > 0) {
    throw new Error("[Modal.".concat(currentSlotName, "] Warning, there are too many ").concat(checkNumberOfOccurences.join(", "), " element(s)"));
  }
  if (errorElements.length > 0) {
    throw new Error("[Modal.".concat(currentSlotName, "] Please provide valid ").concat(errorElements.join(", "), " element(s)"));
  }
};
var childrenHasIcon = function childrenHasIcon(children) {
  return React.Children.toArray(children).some(function (child) {
    var _child$type2, _child$props;
    var isSymbol = (child === null || child === void 0 || (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.name) === MODAL_ELEMENTS.SYMBOL;
    var isIcon = (_child$props = child.props) === null || _child$props === void 0 || (_child$props = _child$props.icon) === null || _child$props === void 0 ? void 0 : _child$props.id;
    return isSymbol && isIcon;
  });
};
var getModalChildren = function getModalChildren(children, destination, slotName) {
  checkElementsValidity(slotName, destination, children);
  if (!children) {
    return null;
  }
  var content = React.Children.map(children, function (child) {
    var _child$type3;
    var isValidElement = /*#__PURE__*/React.isValidElement(child);
    var childTypeName = child === null || child === void 0 || (_child$type3 = child.type) === null || _child$type3 === void 0 ? void 0 : _child$type3.name;
    var isValidBodyElement = destination === MODAL_ELEMENTS.BODY;
    var isValidDestination = !isValidBodyElement && isValidElement && destination[childTypeName];
    if (isValidDestination || isValidBodyElement) {
      return child;
    }
    return null;

    // Ignore `null` entries
  }).filter(Boolean);
  return content;
};
var getBodyChildren = function getBodyChildren(children) {
  if (!children || children.length === 0) {
    throw new Error("[Modal.Body] Please, add a valid Modal.Body element");
  }
  return getModalChildren(children, MODAL_ELEMENTS.BODY, "Body");
};
var getHeaderChildren = function getHeaderChildren(children) {
  var content = getModalChildren(children, MODAL_HEADER_ELEMENTS, "Header");
  if (!content) {
    return null;
  }
  var hasIcon = childrenHasIcon(children);
  return {
    content: content,
    hasIcon: hasIcon
  };
};
var getFooterChildren = function getFooterChildren(children) {
  var content = getModalChildren(children, MODAL_FOOTER_ELEMENTS, "Footer");
  if (!content) {
    return null;
  }
  var numberOfButtons = React.Children.count(content);
  if (numberOfButtons > 1) {
    return React.Children.map(content, function (child, index) {
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
        variant: index ? MODAL_BUTTON_VARIANTS.REGULAR : MODAL_BUTTON_VARIANTS.NAKED
      }));

      // Ignore `null` entries
    }).filter(Boolean);
  }
  return content;
};
export var spreadChildren = function spreadChildren(children) {
  var headerChildren = [];
  var headerHasIcon = false;
  var footerChildren = [];
  var bodyChildren = [];
  if (children) {
    checkElementsValidity("Layout", MODAL_LAYOUT_ELEMENTS, children);

    // eslint-disable-next-line consistent-return
    React.Children.forEach(children, function (child) {
      var _child$type4, _child$props2;
      var childLayoutTypeName = child === null || child === void 0 || (_child$type4 = child.type) === null || _child$type4 === void 0 ? void 0 : _child$type4.name;
      var subChildren = child === null || child === void 0 || (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.children;
      if (! /*#__PURE__*/React.isValidElement(child) && !MODAL_LAYOUT_ELEMENTS[childLayoutTypeName]) {
        return null;
      }
      if (childLayoutTypeName === MODAL_ELEMENTS.HEADER) {
        var _getHeaderChildren = getHeaderChildren(subChildren),
          content = _getHeaderChildren.content,
          hasIcon = _getHeaderChildren.hasIcon;
        headerChildren = content;
        headerHasIcon = hasIcon;
      }
      if (childLayoutTypeName === MODAL_ELEMENTS.FOOTER) {
        footerChildren = getFooterChildren(subChildren);
      }
      if (childLayoutTypeName === MODAL_ELEMENTS.BODY) {
        bodyChildren = getBodyChildren(subChildren);
      }
    });
  }
  return {
    headerChildren: headerChildren,
    headerHasIcon: headerHasIcon,
    footerChildren: footerChildren,
    bodyChildren: bodyChildren
  };
};